import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i4 from '@angular/material/list';
import { MatListModule } from '@angular/material/list';
import * as i5 from '@ngx-translate/core';
import { AzavistaSharedModule } from '@azavista/components/shared';
const _c0 = (a0, a1) => ({
  "menu-collapsed": a0,
  "menu-expanded": a1
});
const _c1 = (a0, a1) => ({
  "icon-provided": a0,
  "icon-not-provided": a1
});
const _c2 = a0 => ({
  "aza-flyout-menu-container": a0
});
function AzavistaSideNavComponent_ng_container_1_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const menuItem_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, menuItem_r2.textTranslationKey));
  }
}
function AzavistaSideNavComponent_ng_container_1_div_6_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵlistener("click", function AzavistaSideNavComponent_ng_container_1_div_6_div_7_Template_div_click_0_listener($event) {
      const child_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.onFlyoutMenuClicked(child_r6, $event));
    });
    i0.ɵɵelementStart(1, "a", 21)(2, "mat-icon", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 22);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const child_r6 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", child_r6.routerLink)("queryParams", child_r6.queryParams);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c1, child_r6.icon, !child_r6.icon));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(child_r6.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 5, child_r6.textTranslationKey));
  }
}
function AzavistaSideNavComponent_ng_container_1_div_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "div", 17)(2, "a", 18);
    i0.ɵɵlistener("click", function AzavistaSideNavComponent_ng_container_1_div_6_Template_a_click_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const menuItem_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onFlyoutMenuClicked(menuItem_r2, $event));
    });
    i0.ɵɵelementStart(3, "strong");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(6, "mat-divider");
    i0.ɵɵtemplate(7, AzavistaSideNavComponent_ng_container_1_div_6_div_7_Template, 7, 10, "div", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const menuItem_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("transform", menuItem_r2.transform);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c2, ctx_r2.shouldBeFlyout(menuItem_r2)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("routerLink", menuItem_r2.routerLink)("queryParams", menuItem_r2.queryParams);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 7, menuItem_r2.textTranslationKey));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", menuItem_r2.children);
  }
}
function AzavistaSideNavComponent_ng_container_1_ng_container_7_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵlistener("click", function AzavistaSideNavComponent_ng_container_1_ng_container_7_div_1_Template_div_click_0_listener($event) {
      const child_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.onChildMenuClicked(child_r8, $event));
    });
    i0.ɵɵelementStart(1, "a", 21)(2, "mat-icon", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span", 22);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const child_r8 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", child_r8.routerLink)("queryParams", child_r8.queryParams);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c1, child_r8.icon, !child_r8.icon));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(child_r8.icon);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 5, child_r8.textTranslationKey));
  }
}
function AzavistaSideNavComponent_ng_container_1_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaSideNavComponent_ng_container_1_ng_container_7_div_1_Template, 7, 10, "div", 23);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const menuItem_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", menuItem_r2.children);
  }
}
function AzavistaSideNavComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵlistener("mouseenter", function AzavistaSideNavComponent_ng_container_1_Template_div_mouseenter_1_listener($event) {
      const menuItem_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onMouseEnter(menuItem_r2, $event));
    })("mouseleave", function AzavistaSideNavComponent_ng_container_1_Template_div_mouseleave_1_listener($event) {
      const menuItem_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onMouseLeave(menuItem_r2, $event));
    });
    i0.ɵɵelementStart(2, "a", 10);
    i0.ɵɵlistener("click", function AzavistaSideNavComponent_ng_container_1_Template_a_click_2_listener($event) {
      const menuItem_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.onMenuClicked(menuItem_r2, $event));
    });
    i0.ɵɵelementStart(3, "mat-icon", 11);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, AzavistaSideNavComponent_ng_container_1_span_5_Template, 3, 3, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, AzavistaSideNavComponent_ng_container_1_div_6_Template, 8, 11, "div", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, AzavistaSideNavComponent_ng_container_1_ng_container_7_Template, 2, 1, "ng-container", 14);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const menuItem_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("expanded-nav-item-parent-container", menuItem_r2.expanded);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("expanded-parent-menu-item", menuItem_r2.expanded);
    i0.ɵɵproperty("routerLink", menuItem_r2.routerLink)("queryParams", menuItem_r2.queryParams);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(11, _c1, menuItem_r2.icon, !menuItem_r2.icon));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(menuItem_r2.icon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.sidebarCollapsed);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.shouldShowFlyout(menuItem_r2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.shouldShowChildren(menuItem_r2));
  }
}
function AzavistaSideNavComponent_mat_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 25);
    i0.ɵɵtext(1, "chevron_left");
    i0.ɵɵelementEnd();
  }
}
function AzavistaSideNavComponent_mat_icon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 26);
    i0.ɵɵtext(1, "chevron_right");
    i0.ɵɵelementEnd();
  }
}
function AzavistaSideNavComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27)(1, "mat-icon", 28);
    i0.ɵɵtext(2, "chevron_left");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 29);
    i0.ɵɵtext(4, "COLLAPSE");
    i0.ɵɵelementEnd()();
  }
}
function AzavistaSideNavComponent_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30)(1, "mat-icon", 28);
    i0.ɵɵtext(2, "chevron_right");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span");
    i0.ɵɵelementEnd();
  }
}
let AzavistaSideNavComponent = /*#__PURE__*/(() => {
  class AzavistaSideNavComponent {
    constructor() {
      this.collapsed = new EventEmitter();
      this.menuClicked = new EventEmitter();
      this.sidebarCollapsed = false;
    }
    onMenuClicked(menuItem, ev) {
      // Collapse all other top-level menus and expand this one if it has children
      for (const menu of this.data.menuItems) {
        menu.expanded = false;
      }
      if (menuItem.children && menuItem.children.length) {
        menuItem.expanded = true;
      }
      this.hoveredMenu = null;
      this.menuClicked.next(menuItem);
    }
    onChildMenuClicked(menuItem, ev) {
      this.hoveredMenu = null;
      this.menuClicked.next(menuItem);
    }
    onFlyoutMenuClicked(menuItem, ev) {
      ev.preventDefault();
      ev.stopPropagation();
      this.hoveredMenu = null;
      this.menuClicked.next(menuItem);
    }
    onMouseEnter(menuItem, ev) {
      if (menuItem.expanded && !this.sidebarCollapsed) {
        // The menu is expanded and visible (sidebar not collapsed) - do not show flyout menu
        return;
      }
      this.hoveredMenu = menuItem;
      const targetEl = ev.target;
      const boundingRect = targetEl.getBoundingClientRect();
      // Subtraction of one pixel is needed in order to not hide the menu when mouse moves from its parent to it
      // If no subtraction is made, there is a 1 pixel gap between them which causes mouseleave for the parent and closing the flyout menu
      const flyoutMenuLeft = boundingRect.right - 1;
      const flyoutMenuTop = this.getMenuYPositionOffset(boundingRect.top, menuItem.children?.length);
      menuItem.transform = `translate(${flyoutMenuLeft}px, ${flyoutMenuTop}px)`;
    }
    getMenuYPositionOffset(top, menuItemChildrens) {
      const viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
      const pixelsPerMenuItemChild = 47;
      const flyoutMenuHeight = pixelsPerMenuItemChild * (menuItemChildrens || 0);
      const rollUpMenuViewportBreakpoint = viewportHeight - flyoutMenuHeight - pixelsPerMenuItemChild; // last item is just extra space
      if (top < rollUpMenuViewportBreakpoint) {
        return top; // the menu rolls down
      } else {
        return top - flyoutMenuHeight; // the menu rolls up
      }
    }
    onMouseLeave(menuItem, ev) {
      this.hoveredMenu = null;
    }
    shouldBeFlyout(menuItem) {
      return !menuItem.expanded || this.sidebarCollapsed;
    }
    shouldShowFlyout(menuItem) {
      const shouldBeFlyout = this.shouldBeFlyout(menuItem);
      const isHovered = this.hoveredMenu === menuItem;
      return shouldBeFlyout && isHovered;
    }
    shouldShowChildren(menuItem) {
      if (menuItem.expanded && !this.sidebarCollapsed) {
        return true;
      }
      return false;
    }
    toggleSidebarCollapsedState() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
      if (this.sidebarCollapsed) {
        // Collapse all parent menus
        for (const item of this.data.menuItems) {
          if (item.expanded) {
            this.expandedMenuBeforeSidebarCollapse = item;
          }
          item.expanded = false;
        }
      } else {
        // Find the menu that was expanded before collapsing (if any)
        if (this.expandedMenuBeforeSidebarCollapse) {
          for (const item of this.data.menuItems) {
            if (item === this.expandedMenuBeforeSidebarCollapse) {
              item.expanded = true;
            }
          }
        }
      }
      this.collapsed.emit(this.sidebarCollapsed);
    }
    isChild(menuItem) {
      for (const item of this.data.menuItems) {
        if (item === menuItem) {
          return false;
        }
        for (const child of item.children) {
          if (menuItem === child) {
            return true;
          }
        }
      }
      return false;
    }
    static {
      this.ɵfac = function AzavistaSideNavComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaSideNavComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaSideNavComponent,
        selectors: [["azavista-side-nav"]],
        inputs: {
          data: "data"
        },
        outputs: {
          collapsed: "collapsed",
          menuClicked: "menuClicked"
        },
        standalone: false,
        decls: 9,
        vars: 13,
        consts: [[1, "nav-root-items", "azavista-side-nav-component"], [4, "ngFor", "ngForOf"], [1, "middle-collapse-container", "mat-elevation-z4", "aza-cmp-flex-row", "aza-cmp-vertical-middle-of-parent", "aza-cmp-background-color-light", "aza-cmp-cursor-hand", 3, "click", "ngClass"], ["class", "collapse-icon", 4, "ngIf"], ["class", "expand-icon", 4, "ngIf"], [1, "collapse-button-container", "aza-cmp-background-color-light", "aza-cmp-cursor-hand", 3, "click", "ngClass"], [1, "collapse-link", "parent-menu-item", "aza-cmp-half-gap", "aza-cmp-grid", "aza-cmp-half-padding"], ["class", "side-nav-collapse-button aza-cmp-flex-row", 4, "ngIf"], ["class", "side-nav-expand-button aza-cmp-flex-row", 4, "ngIf"], [1, "nav-item-container", "nav-item-parent-container", "aza-cmp-half-padding-block", "aza-cmp-cursor-hand", 3, "mouseenter", "mouseleave"], ["routerLinkActive", "azavista-side-nav-router-link-active-parent", 1, "parent-menu-item", "aza-cmp-half-gap", "menu-link", "aza-cmp-grid", "aza-cmp-half-padding", 3, "click", "routerLink", "queryParams"], ["matListItemIcon", "", 1, "nav-item-icon", "material-icons-outlined", 3, "ngClass"], ["class", "menu-item-text", 4, "ngIf"], ["class", "aza-cmp-background-color-light mat-elevation-z4", 3, "ngClass", "transform", 4, "ngIf"], [4, "ngIf"], [1, "menu-item-text"], [1, "aza-cmp-background-color-light", "mat-elevation-z4", 3, "ngClass"], [1, "aza-flyout-menu-header-item-container", "aza-flyout-menu-item-container", "aza-cmp-flex-row", "aza-cmp-padding"], [1, "flyout-header-item", "menu-link", 3, "click", "routerLink", "queryParams"], ["class", "aza-flyout-menu-item-container aza-cmp-half-padding", 3, "click", 4, "ngFor", "ngForOf"], [1, "aza-flyout-menu-item-container", "aza-cmp-half-padding", 3, "click"], ["routerLinkActive", "azavista-side-nav-router-link-active-child", 1, "child-menu-item", "menu-link", "aza-cmp-grid", "aza-cmp-half-gap", "aza-cmp-half-padding", 3, "routerLink", "queryParams"], [1, "menu-child-item-text"], ["class", "nav-item-container nav-item-child-container aza-cmp-half-padding-block aza-cmp-cursor-hand", 3, "click", 4, "ngFor", "ngForOf"], [1, "nav-item-container", "nav-item-child-container", "aza-cmp-half-padding-block", "aza-cmp-cursor-hand", 3, "click"], [1, "collapse-icon"], [1, "expand-icon"], [1, "side-nav-collapse-button", "aza-cmp-flex-row"], ["matListItemIcon", ""], ["translate", ""], [1, "side-nav-expand-button", "aza-cmp-flex-row"]],
        template: function AzavistaSideNavComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-nav-list", 0);
            i0.ɵɵtemplate(1, AzavistaSideNavComponent_ng_container_1_Template, 8, 14, "ng-container", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵlistener("click", function AzavistaSideNavComponent_Template_div_click_2_listener() {
              return ctx.toggleSidebarCollapsedState();
            });
            i0.ɵɵtemplate(3, AzavistaSideNavComponent_mat_icon_3_Template, 2, 0, "mat-icon", 3)(4, AzavistaSideNavComponent_mat_icon_4_Template, 2, 0, "mat-icon", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 5);
            i0.ɵɵlistener("click", function AzavistaSideNavComponent_Template_div_click_5_listener() {
              return ctx.toggleSidebarCollapsedState();
            });
            i0.ɵɵelementStart(6, "a", 6);
            i0.ɵɵtemplate(7, AzavistaSideNavComponent_div_7_Template, 5, 0, "div", 7)(8, AzavistaSideNavComponent_div_8_Template, 4, 0, "div", 8);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.data.menuItems);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c0, ctx.sidebarCollapsed, !ctx.sidebarCollapsed));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.sidebarCollapsed);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.sidebarCollapsed);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(10, _c0, ctx.sidebarCollapsed, !ctx.sidebarCollapsed));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.sidebarCollapsed);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.sidebarCollapsed);
          }
        },
        dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2.RouterLink, i2.RouterLinkActive, i3.MatIcon, i4.MatNavList, i4.MatListItemIcon, i4.MatDivider, i5.TranslateDirective, i5.TranslatePipe],
        styles: [".nav-root-items[_ngcontent-%COMP%]{padding-bottom:56px}.parent-menu-item[_ngcontent-%COMP%], .child-menu-item[_ngcontent-%COMP%]{grid-template-columns:min-content auto}.aza-flyout-menu-container[_ngcontent-%COMP%]{position:fixed;top:0;left:0;min-width:200px;max-width:400px;z-index:10}.menu-link[_ngcontent-%COMP%]{text-decoration:none}.middle-collapse-container[_ngcontent-%COMP%]{right:0;border-radius:50%}.collapse-button-container[_ngcontent-%COMP%]{bottom:0;position:fixed}"]
      });
    }
  }
  return AzavistaSideNavComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaSideNavModule = /*#__PURE__*/(() => {
  class AzavistaSideNavModule {
    static {
      this.ɵfac = function AzavistaSideNavModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaSideNavModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AzavistaSideNavModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, RouterModule, MatIconModule, MatListModule, AzavistaSharedModule]
      });
    }
  }
  return AzavistaSideNavModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AzavistaSideNavComponent, AzavistaSideNavModule };
